import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Group } from 'three';

import { Clone } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';

import { useModelLoader } from '../../hooks/index.js';

export interface ModelPreviewAssetProps {
  rotate: boolean;
  url: string;
}
export const ModelPreviewAsset = forwardRef<Group, ModelPreviewAssetProps>(
  ({ rotate, url }, ref) => {
    const groupRef = useRef<Group>(null);
    const { invalidate } = useThree();
    const { scene } = useModelLoader(url);
    useImperativeHandle(ref, () => groupRef.current || new Group());

    useFrame(() => {
      if (rotate) {
        groupRef.current?.rotateY(0.01);
        invalidate();
      } else {
        groupRef.current?.rotation.set(0, 0, 0);
        invalidate();
      }
    });

    useEffect(() => {
      invalidate();
    }, [rotate, invalidate]);

    return <Clone ref={groupRef} castShadow object={scene} position={[0, 0, 0]} />;
  }
);
